import React, { useEffect, useState } from "react";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import IpSettingsFilter from "./IpSettingsFilter";
import { checkButtonAccess } from "../../../Utils/CommonUtils";
import { useDispatch, useSelector } from "react-redux";
import useIpSettingsColumn from "./Hooks/useIpSettingsColumn";
import NewUserIpSettingsModal from "./Modal/NewUserIpSettingsModal";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import { readIpSettings } from "./IpSettingsService";
import useRezReactTable from "../../../Components/Common/Tables/Tanstack/hooks/useRezReactTable";
import rootReducer from "../../../store";
import { openModal } from "../../../slices/common/reducer";
import {
  setIpSorting,
  setWhiteListedData,
} from "../../../slices/IpSettings/ipSettingsSlice";

const IpSettingsListing = () => {
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  const enterpriseid = localStorage.getItem("enterpriseid");
  const whiteListedData = useSelector(
    (state) => state.ipSettings.whiteListedData
  );
  const dispatch = useDispatch();

  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const rowsPerPage = useSelector((state) => state.common.pagination.size);
  // const enterpriseId = useSelector((state) => state.common.user.enterpriseId);
  const pageNumber = useSelector((state) => state.common.pagination.page);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.ipSettings.filter.filterApi);
  const filterForm = useSelector((state) => state.ipSettings.filter.form);
  const filterFormCopy = useSelector(
    (state) => state.ipSettings.filter.formCopy
  );
  const sortColumn = useSelector((state) => state.ipSettings.sorting.column);
  const sortOrder = useSelector((state) => state.ipSettings.sorting.order);

  const handleIpSettingModalOpen = () => {
    rootReducer.dispatch(openModal(true));
  };
  const { IpSettingsColumns } = useIpSettingsColumn(handleIpSettingModalOpen);

  return (
    <div>
      <CommonHeader
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "SETN_IPWL")}
        buttonTitle={"New IP"}
        filterComponent={<IpSettingsFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={IpSettingsColumns}
          data={whiteListedData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"IP"}
          filterApiListEntity={"IP"}
          filterApiFunction={setWhiteListedData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setIpSorting}
        />
      </div>
      {(modalShow || editShow) && <NewUserIpSettingsModal />}
    </div>
  );
};

export default IpSettingsListing;
